import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-api",
  "use": "icon-api-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-api\"><defs><style type=\"text/css\"></style></defs><path d=\"M832 704c38.4 0 64 25.6 64 64s-25.6 64-64 64H364.8c-19.2 38.4-64 64-108.8 64-70.4 0-128-57.6-128-128s57.6-128 128-128c44.8 0 89.6 25.6 108.8 64H832zM576 128c44.8 0 89.6 25.6 108.8 64H832c38.4 0 64 25.6 64 64s-25.6 64-64 64h-147.2c-19.2 38.4-64 64-108.8 64s-89.6-25.6-108.8-64H192c-38.4 0-64-25.6-64-64s25.6-64 64-64h275.2c19.2-38.4 64-64 108.8-64zM448 448h384c38.4 0 64 25.6 64 64s-25.6 64-64 64H448c-38.4 0-64-25.6-64-64s25.6-64 64-64zM192 448h64c38.4 0 64 25.6 64 64s-25.6 64-64 64H192c-38.4 0-64-25.6-64-64s25.6-64 64-64z m384-128c38.4 0 64-25.6 64-64s-25.6-64-64-64-64 25.6-64 64 25.6 64 64 64z m-320 512c38.4 0 64-25.6 64-64s-25.6-64-64-64-64 25.6-64 64 25.6 64 64 64z\" p-id=\"8559\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/api.svg
// module id = Mz/u
// module chunks = 7